"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatsForNerds = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _DropdownTrigger = require("../primitives/DropdownTrigger");
var _useUISettings = require("./AppData/useUISettings");
var _useDropdownSelection = require("./hooks/useDropdownSelection");
var _constants = require("../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var StatsForNerds = function StatsForNerds(_ref) {
  var _statsOptions$find, _ref$current;
  var onOpenChange = _ref.onOpenChange;
  var tracksWithLabels = useTracksWithLabel();
  var statsOptions = (0, _react.useMemo)(function () {
    return [{
      id: "local-peer",
      label: "Local Peer Stats"
    }].concat(_toConsumableArray(tracksWithLabels));
  }, [tracksWithLabels]);
  var _useState = (0, _react.useState)("local-peer"),
    _useState2 = _slicedToArray(_useState, 2),
    selectedStat = _useState2[0],
    setSelectedStat = _useState2[1];
  var _useSetUiSettings = (0, _useUISettings.useSetUiSettings)(_constants.UI_SETTINGS.showStatsOnTiles),
    _useSetUiSettings2 = _slicedToArray(_useSetUiSettings, 2),
    showStatsOnTiles = _useSetUiSettings2[0],
    setShowStatsOnTiles = _useSetUiSettings2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var ref = (0, _react.useRef)();
  var selectionBg = (0, _useDropdownSelection.useDropdownSelection)();
  (0, _react.useEffect)(function () {
    if (selectedStat !== "local-peer" && !tracksWithLabels.find(function (track) {
      return track.id === selectedStat;
    })) {
      setSelectedStat("local-peer");
    }
  }, [tracksWithLabels, selectedStat]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Root, {
    defaultOpen: true,
    onOpenChange: onOpenChange,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Portal, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Overlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Content, {
        css: {
          width: "min(500px, 95%)"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Title, {
          css: {
            p: "$4 0"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
            justify: "between",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
              align: "center",
              css: {
                mb: "$1"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                variant: "h6",
                inline: true,
                children: "Stats For Nerds"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.DefaultClose, {
              "data-testid": "stats_dialog_close_icon"
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.HorizontalDivider, {
          css: {
            mt: "0.8rem"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
          justify: "start",
          gap: 4,
          css: {
            m: "$10 0"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Switch, {
            checked: showStatsOnTiles,
            onCheckedChange: setShowStatsOnTiles
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "body2",
            css: {
              fontWeight: "$semiBold"
            },
            children: "Show Stats on Tiles"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
          direction: "column",
          css: {
            mb: "$12",
            position: "relative",
            minWidth: 0
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Label, {
            variant: "body2",
            children: "Stats For"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
            "data-testid": "dialog_select_Stats For",
            open: open,
            onOpenChange: setOpen,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownTrigger.DialogDropdownTrigger, {
              title: ((_statsOptions$find = statsOptions.find(function (_ref2) {
                var id = _ref2.id;
                return id === selectedStat;
              })) === null || _statsOptions$find === void 0 ? void 0 : _statsOptions$find.label) || "Select Stats",
              css: {
                mt: "$4"
              },
              titleCSS: {
                mx: 0
              },
              open: open,
              ref: ref
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Portal, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Content, {
                align: "start",
                sideOffset: 8,
                css: {
                  w: (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth,
                  zIndex: 1000
                },
                children: statsOptions.map(function (option) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Item, {
                    onClick: function onClick() {
                      setSelectedStat(option.id);
                    },
                    css: {
                      px: "$9",
                      bg: option.id === selectedStat ? selectionBg : undefined,
                      c: option.id === selectedStat ? "$white" : "$textPrimary"
                    },
                    children: option.label
                  }, option.id);
                })
              })
            })]
          })]
        }), selectedStat === "local-peer" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(LocalPeerStats, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(TrackStats, {
          trackID: selectedStat
        })]
      })]
    })
  });
};
exports.StatsForNerds = StatsForNerds;
var useTracksWithLabel = function useTracksWithLabel() {
  var tracksMap = (0, _reactSdk.useHMSStore)(_reactSdk.selectTracksMap);
  var peersMap = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeersMap);
  var tracksWithLabels = (0, _react.useMemo)(function () {
    return Object.values(tracksMap).map(function (track) {
      var _peersMap$track$peerI;
      var peerName = (_peersMap$track$peerI = peersMap[track.peerId]) === null || _peersMap$track$peerI === void 0 ? void 0 : _peersMap$track$peerI.name;
      return {
        id: track.id,
        label: "".concat(peerName, " ").concat(track.source, " ").concat(track.type)
      };
    });
  }, [tracksMap, peersMap]);
  return tracksWithLabels;
};
var LocalPeerStats = function LocalPeerStats() {
  var _stats$subscribe, _stats$subscribe2, _stats$publish, _stats$subscribe3, _stats$publish2, _stats$subscribe4;
  var stats = (0, _reactSdk.useHMSStatsStore)(_reactSdk.selectHMSStats.localPeerStats);
  if (!stats) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      flexWrap: "wrap",
      gap: "$10"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Packets Lost",
      value: (_stats$subscribe = stats.subscribe) === null || _stats$subscribe === void 0 ? void 0 : _stats$subscribe.packetsLost
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Jitter",
      value: (_stats$subscribe2 = stats.subscribe) === null || _stats$subscribe2 === void 0 ? void 0 : _stats$subscribe2.jitter
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Publish Bitrate",
      value: formatBytes((_stats$publish = stats.publish) === null || _stats$publish === void 0 ? void 0 : _stats$publish.bitrate, "b/s")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Subscribe Bitrate",
      value: formatBytes((_stats$subscribe3 = stats.subscribe) === null || _stats$subscribe3 === void 0 ? void 0 : _stats$subscribe3.bitrate, "b/s")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Total Bytes Sent",
      value: formatBytes((_stats$publish2 = stats.publish) === null || _stats$publish2 === void 0 ? void 0 : _stats$publish2.bytesSent)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Total Bytes Received",
      value: formatBytes((_stats$subscribe4 = stats.subscribe) === null || _stats$subscribe4 === void 0 ? void 0 : _stats$subscribe4.bytesReceived)
    })]
  });
};
var TrackStats = function TrackStats(_ref3) {
  var trackID = _ref3.trackID;
  var stats = (0, _reactSdk.useHMSStatsStore)(_reactSdk.selectHMSStats.trackStatsByID(trackID));
  if (!stats) {
    return null;
  }
  var inbound = stats.type.includes("inbound");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      flexWrap: "wrap",
      gap: "$10"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Type",
      value: stats.type + " " + stats.kind
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Bitrate",
      value: formatBytes(stats.bitrate, "b/s")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Packets Lost",
      value: stats.packetsLost || "-"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: "Jitter",
      value: stats.jitter || "-"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
      label: inbound ? "Bytes Received" : "Bytes Sent",
      value: formatBytes(inbound ? stats.bytesReceived : stats.bytesSent)
    }), stats.kind === "video" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
        label: "Framerate",
        value: stats.framesPerSecond
      }), !inbound && /*#__PURE__*/(0, _jsxRuntime.jsx)(StatsRow, {
        label: "Quality Limitation Reason",
        value: stats.qualityLimitationReason || "-"
      })]
    })]
  });
};
var StatsRow = function StatsRow(_ref4) {
  var label = _ref4.label,
    value = _ref4.value;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      bg: "$surfaceLight",
      w: "calc(50% - $6)",
      p: "$8",
      r: "$3"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
      variant: "overline",
      css: {
        fontWeight: "$semiBold",
        color: "$textMedEmp",
        textTransform: "uppercase"
      },
      children: [label, " "]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "sub1",
      css: {
        fontWeight: "$semiBold",
        color: "$textHighEmp"
      },
      children: value
    })]
  });
};
var formatBytes = function formatBytes(bytes) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "B";
  var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  if (bytes === 0) return "0 " + unit;
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ["", "K", "M", "G", "T", "P", "E", "Z", "Y"].map(function (size) {
    return size + unit;
  });
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};